<template>
  <nav>
    <ul>
      <li v-for="item in menuItems" :key="item.name">
        <router-link :to="item.path">{{ item.name }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "NavMenu",
  data() {
    return {
      menuItems: [
        { name: "首页", path: "/" },
        { name: "关于我们", path: "/about" },
        { name: "服务", path: "/services" },
        { name: "联系我们", path: "/contact" },
      ],
    };
  },
};
</script>

<style scoped>
nav ul {
  list-style-type: none;
  padding: 0;
}
nav ul li {
  display: inline;
  margin-right: 10px;
}
nav ul li a {
  text-decoration: none;
  color: #333;
}
nav ul li a.router-link-active {
  color: #42b983; /* Highlight active link */
}
</style>
